import { AppNS } from 'app';
import axios, { Canceler } from 'axios';

import { API_URL } from '../../core/config';
import { getErrorMessagesAsArray } from '../helpers/errorHandling';
import { parseReport } from './client-reports-parsers';

const URL = 'reports';
const REPORTS_URL = 'reports';

const CancelToken = axios.CancelToken;
let cancel: Canceler;

export function apiGetReport(id: string): Promise<AppNS.JobEventReport> {
  if (cancel !== undefined) {
    cancel();
  }
  return new Promise((resolve, reject) => {
    axios
      .get(`${API_URL}/${URL}/${id}.json`, {
        cancelToken: new CancelToken(function executor(c) {
          // An executor function receives a cancel function as a parameter
          cancel = c;
        }),
      })
      .then(({ data }) => {
        if (data.model) {
          resolve(parseReport(data.model));
        } else {
          reject('Invalid response data');
        }
      })
      .catch((error) => {
        reject(getErrorMessagesAsArray(error));
      });
  });
}

export function apiApproveAndPayReport(
  id: string,
  paymentMethodId: string
): Promise<AppNS.JobEventReport> {
  return new Promise((resolve, reject) => {
    axios
      .patch(`${API_URL}/${REPORTS_URL}/approve-and-pay.json`, {
        id,
        paymentMethodId,
      })
      .then(({ data }) => {
        if (data.model) {
          resolve(data.model);
        } else {
          reject(data.errors || 'Invalid response data');
        }
      })
      .catch((error) => {
        reject(getErrorMessagesAsArray(error));
      });
  });
}
